import { ICurrency } from '@aca-new/app/shared/components/currency-view/shared/models/interfaces/currency.interface';
import { CurrencyFormatService } from '@aca-new/app/shared/services/currency-format/currency-format.service';
import { QimaTooltipService } from '@aca-new/app/shared/services/exported-services/qima-tooltip/qima-tooltip.service';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { QimaOptionalType } from '@qima/ngx-qima';

@Component({
  standalone: false,
  selector: 'app-currency-view',
  templateUrl: './currency-view.component.html',
  styleUrls: ['./currency-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencyViewComponent {
  /**
   * @description
   * The currency
   * @type {QimaOptionalType<ICurrency>}
   * @default undefined
   */
  @Input('currencyViewData')
  public data: QimaOptionalType<ICurrency> = undefined;

  public constructor(
    public readonly qimaTooltip: QimaTooltipService,
    private readonly _currencyFormatService: CurrencyFormatService
  ) {}

  public formatAmount(value: string | number | null | undefined, code: string): string {
    return this._currencyFormatService.formatAmount(value, code);
  }
}
